function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0z" /><path d="M12 2c5.52 0 10 3.98 10 8.89a5.56 5.56 0 0 1-5.56 5.55h-1.96a1.67 1.67 0 0 0-1.25 2.77c.27.3.44.69.44 1.12 0 .93-.77 1.67-1.67 1.67a10 10 0 0 1 0-20zm-1.19 16.11a3.66 3.66 0 0 1 3.67-3.67h1.96A3.56 3.56 0 0 0 20 10.9C20 7.14 16.47 4 12 4a8 8 0 0 0-.68 15.97 3.65 3.65 0 0 1-.5-1.86zM7.5 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" /></svg>;
});